import { CreateBudgetCategoryGroup } from "@project/domain/models/budget/budget-category/groups/create-budget-category-group.model";

export class EditBudgetCategoryGroup extends CreateBudgetCategoryGroup {
    constructor(
        public readonly id: number,
        name: CreateBudgetCategoryGroup["name"],
        category: CreateBudgetCategoryGroup["category"],
        expense_type_mapping?: CreateBudgetCategoryGroup["expense_type_mapping"],
        expense_subtype_mapping?: CreateBudgetCategoryGroup["expense_subtype_mapping"],
    ) {
        super(name, category, expense_type_mapping, expense_subtype_mapping);
    }
}
